<template>
  <v-card flat fill-height style="width:400px;background-color:rgb(244,244,244);">
    <v-card-title class="title" style="color:rgb(51,82,128);height:40px;">Alerts</v-card-title>
    <v-card-text id="alertMenuCont">
      <v-container fluid fill-height grid-list-md style="padding:5px;">
        <v-layout fill-height column>
          <v-flex v-for="item in alerts" :key="item">
            <v-card flat class="hoverCard" fill-height style="background-color:rgb(219,219,219);">
              <v-container fluid grid-list-md style="padding:5px;height:100%; font-size: 12px; line-height: 14px;">
                <v-layout row fill-height>
                  <v-flex d-flex md4>
                    <v-layout column fill-height>
                      <v-flex d-flex v-for="param in parameters" :key="param" style="padding-left:10px;">{{ param }}:</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex d-flex md5>
                    <v-layout column fill-height>
                      <v-flex d-flex v-for="param in parameters" :key="param">
                        <div v-if="param=='Fault'" class="hoverTitle" v-on:click="select(item)" style="width:100%;height:100%;">{{ item[param] }}</div>
                        <div v-else style="width:100%;height:100%;">{{ item[param] }}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex d-flex md3>{{ item.faultDatetime.date.slice(0, 10) }}<br>{{ item.faultDatetime.date.slice(11, 19) }}</v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import {globalStore, vessels} from "../main.js"
import {getData} from "../getData.js";
import axios from 'axios'

var apiService;

export default {
  name: "AlertMenu",
  components: {},
  data() {
    return {
      parameters: ['Vessel', 'Component', 'Subsystem', 'Fault']
    }
  },
  created() {
    apiService = new getData(globalStore.userProfile, false);
  },
  computed: {
    alerts: function () {
      return globalStore.alerts;
    }
  },
  mounted() {
  },
  methods: {
    goToAlerts() {
      this.$router.push({path: 'alerts'});
    },
    dismissAll() {
      axios.post(globalStore.config.api_location + '/notifications/dismish/', {selected: []}, {headers: {Authorization: globalStore.auth_token}}).then(() => {
        globalStore.alerts = [];
      }).catch(() => {
        globalStore.alerts = [];
      });
    },
    select(item) {
      var vesselList = Object.values(vessels.vessels),
          vess = vesselList.find(vessel => vessel.name == item.Vessel);

      if (typeof item.faultDatetime.date != 'undefined') {
        globalStore.alertDate = item.faultDatetime.date.slice(0, 10);
      } else {
        globalStore.alertDate = item.faultDatetime.slice(0, 10);
      }

      globalStore.notificationId = item.notification;

      let url = new URL(window.location.origin)
      url.pathname += `engine-faults/${item.Vessel}`

      if (vess.has_twin) {
        url.pathname += `/engine/${item.faultEngine}`
      }

      url.pathname += `/on/${globalStore.alertDate}/fault/${item.Id}`
      this.$router.push(url.pathname.toString())
    }
  },
  watch: {}
}
</script>

<style scoped>
.hoverTitle {
  color: rgb(95, 158, 239);
}

.hoverTitle:hover {
  color: rgb(51, 82, 128);
}

#alertMenuCont {
  overflow: auto !important;
  padding: 8px !important;
  max-height: 400px !important;
  max-width: 79% !important;
}

@media screen and (orientation: landscape) {
  #alertMenuCont {
    max-width: 100% !important;
  }
}
</style>

